import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: {
      title: {
        'ru': 'Главная',
        'en': 'Home',
      }
    },
    component: Home
  },
  {
    path: '/about',
    name: 'About',
    meta: {
      title: {
        'ru': 'О себе',
        'en': 'About me',
      }
    },
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/About.vue')
    }
  },
  {
    path: '/contacts',
    name: 'contacts',
    meta: {
      title: {
        'ru': 'Контакты',
        'en': 'Contacts',
      }
    },
    component: function () {
      return import(/* webpackChunkName: "contacts" */ '../views/Contacts.vue')
    }
  },
  {
    path: '/portfolio',
    name: 'Portfolio',
    meta: {
      title: {
        'ru': 'Мои работы',
        'en': 'Portfolio',
      }
    },
    component: function () {
      return import(/* webpackChunkName: "portfolio" */ '../views/Portfolio.vue')
    }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
